import Alien from './alien';

export default class GreenAlien extends Alien {
    constructor(x, y) {
        super(x, y);
        this.shadow.y += 3;
        this.animations.add('idle', ["alienG_i.png"]);
        this.animations.add('move', ["alienG_w01.png","alienG_w02.png","alienG_w03.png"], 8, true);
        this.animations.add('attack', ["alienG_a01.png","alienG_a02.png","alienG_a03.png","alienG_a04.png"], 8, true);
        this.animations.add('die', ["alienG_d01.png","alienG_d02.png","alienG_d03.png"], 8);
    }

    get corpseFrame() {
        return "alienG_d02.png";
    }


    get attackTimeMs() {
        return 3000;
    }

    get movingSpeed() {
        return 80;
    }

}


// WEBPACK FOOTER //
// ./src/objects/items/moveable/green_alien.js